/**
 * Ruta de una unidad: sólo la de arriba y la actual (2026-10-07). Así quien
 * tiene un grupo de trabajo ve su grupo y su unidad, sin poder subir hasta el
 * corporativo y perderse. La de arriba es enlace sólo si puede verla.
 */
import { rec_Mr as Flecha, rec_React as React, rec_Sn as Enlace, rec_puedeAccion as puedeAccion } from "../../runtime/index.jsx";

export function Componente_ik_105_107({ unidad }) {
  if (!unidad) return null;
  const padre = (unidad.ancestros ?? []).at(-1);
  return (
    <div className="flex flex-wrap items-center gap-1 text-sm text-(--text)">
      {padre && (
        <>
          {puedeAccion(`planner.unidad.ver`, padre.id) ? (
            <Enlace to={`/organizacion/${padre.id}`} className="hover:text-(--accent) hover:underline">{padre.nombre}</Enlace>
          ) : (
            <span>{padre.nombre}</span>
          )}
          <Flecha className="h-3.5 w-3.5" />
        </>
      )}
      <span className="text-(--text-h)">{unidad.nombre}</span>
    </div>
  );
}
